import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Checkbox} from "@nextui-org/react";
import axios from "axios";
import { orders_uri } from "../../../../utils/url";
import { toast } from "react-toastify";

export default function AllConfirmModal({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [type, setType] = useState();
  const [load, setLoad] = useState(false);
  const [paytype, setPaytype] = useState();

  const call = () =>{
    callback();
  }

  const Sub = async ()=> {
    setLoad(true);
    try{
        const res = await axios.patch(orders_uri+'/allconfirm', {ids: data, type:type,  paytype: paytype});
        if(res.status === 200){
            toast.success("Амжилттай");
            setType('');
            call();
            onOpenChange(false)
            setLoad(false)
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  function handleChange(event){
    const {value} = event.target
    setType(value)
  }

  function handleChangePaytype(event){
    const {value} = event.target
    setPaytype(value)
  }

  return (
    <>
      <Button size='sm' onPress={onOpen} className="ml-2">Бүгдийг батлах батлах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Баталгаажуулах</ModalHeader>
              <ModalBody>
                <div>
                  <div className="flex items-center gap-2">
                    <Checkbox value={'Ирж авсан'} onChange={handleChange}/>
                    <h1>Ирж авсан</h1>
                  </div>
                  <div className="flex items-center gap-2 mt-2">
                    <Checkbox value={'Хүргэлтээр авсан'} onChange={handleChange}/>
                    <h1>Хүргэлтээр авсан</h1>
                  </div>
                  {
                    type === 'Ирж авсан' &&
                    <>
                      <h1 className="border-t mt-4 pt-4 mb-4 font-bold">Төлбөр төлсөн хэлбэр</h1>
                      <div className="flex items-center gap-2">
                        <Checkbox value={'Дансаар'} onChange={handleChangePaytype}/>
                        <h1>Дансаар </h1>
                      </div>
                      <div className="flex items-center gap-2 mt-2">
                        <Checkbox value={'Бэлнээр'} onChange={handleChangePaytype}/>
                        <h1>Бэлнээр</h1>
                      </div>
                      <div className="flex items-center gap-2 mt-2">
                        <Checkbox value={'Картаар'} onChange={handleChangePaytype}/>
                        <h1>Картаар</h1>
                      </div>
                    </>
                  }
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button className="bg-blue-300">
                        Баталгаажуулж байна ...
                    </Button>
                    :
                    <Button color="primary" onPress={Sub}>
                        Тийм
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
